export const transformOptionsWithIcon = (options, iconCondition, iconConfig) => {
	return options.map((option) => {
		if (iconCondition(option)) {
			return {
				...option,
				icon: iconConfig.src,
				iconAlt: iconConfig.alt || "",
				iconTitle: iconConfig.title || "",
				iconWidth: iconConfig.width || "20px",
			};
		}
		return option;
	});
};
